<template>

  <div id="app" :dark="getDarkSide" :style="`font-family:${getFonts.principal}`" :client="getClient" :route="$route.name">

    <app-header v-if="getLogged"></app-header>

    <div class="wrapper" :has-menu="getLogged">

      <router-view />

    </div>

    <app-footer></app-footer>

    <error-banner></error-banner>

    <template v-if="!getGodmodeStatus">

      <encuestas-obligatorias v-if="showEncuestas"></encuestas-obligatorias>
      
      <rellenar-datos-personales v-if="$route.name != 'cv' && getBrand.popupDatosObligatorios && isAlumno"></rellenar-datos-personales>
      
      <faltan-datos-empresa v-if="showRequestDatosEmpresa"></faltan-datos-empresa>
    </template>

  </div>
</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import loading from '@/components/parts/loading'
  import errorBanner from '@/components/parts/error-banner'

  import encuestasObligatorias from '@/components/parts/encuestas-obligatorias'
  import rellenardatospersonales from '@/components/parts/popup-rellenar-datos-personales'
  import popupFaltanDatosEmpresa from '@/components/parts/popup-faltan-datos-empresa'

  

  import router from '@/router'

  import CookieLaw from 'vue-cookie-law'

  import { mapGetters, mapActions } from 'vuex';

  var jwt_decode = require('jwt-decode');

  export default {
    name: 'App',
    components: {
      'app-header': header,
      'app-footer': footer,
      'loading': loading,
      'cookie-law': CookieLaw,
      'error-banner': errorBanner,
      'encuestas-obligatorias': encuestasObligatorias,
      'rellenar-datos-personales' : rellenardatospersonales,
      'faltan-datos-empresa' : popupFaltanDatosEmpresa
    },
    mounted() {
      this.checkSesion()

      if(this.getDarkSide){
        document.getElementsByTagName("body")[0].classList.add("dark");
      }

    },
    computed: {
      ...mapGetters([
        'getLogged',
        'getDarkSide',
        'getErrorCode',
        'basicColors',
        'getEncuestasObligatorias',
        'getFonts',
        'getFooterLinks',
        'getClient',
        'getBrand',
        'isAlumno',
        'isEmpresa',
        'getGodmodeStatus'
      ]),
      styleWrapper: function () {
        return {
          background: this.basicColors.white,
          color: this.basicColors.dark_black
        }
      },
      showEncuestas: function () {
        let show = (this.getEncuestasObligatorias.length > 0 & this.$route.name != 'ficha_encuestas' & !!this.getLogged);
        return (show == 1) ? true : false;
      },
      showRequestDatosEmpresa(){
        let show = true;

        let notshowin = ['mi_perfil','mi empresa'];

        if(notshowin.some(e => this.$route.name == e)){
          show = false;
        }

        return (show && this.getBrand.checkDatosCompletosEmpresa);

      }
    },
    methods: {
      ...mapActions(['requestAllData', 'setError']),
      checkSesion() {

        if (!!window.localStorage.getItem('_token')) {

          let tokendecoded = jwt_decode(window.localStorage.getItem('_token'));
          let actual = new Date().getTime() / 1000;

          if (actual > tokendecoded.exp) {

            this.setError(2);

          } else {

            if (this.getLogged && this.$route.name != 'ficha_encuestas') {
              this.requestAllData();
            }

          }


        }else{

          if (!!!this.getLogged && this.$route.meta.requiresAuth) {
            router.push('/login');
          }

        }

      }
    }
  }
</script>

<style lang="scss">
  @import "@/assets/css/colors.scss";
  @import "./assets/css/style.scss";
  @import './assets/css/slick.css';
  @import "@/assets/css/brands.scss";
  @import url('https://fonts.googleapis.com/css?family=Lato:300,400,500,600,700,800,900|Nunito:400,700,900');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>


// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/App.vue